import { render, staticRenderFns } from "./IWImage.vue?vue&type=template&id=60bc49e2&scoped=true"
import script from "./IWImage.vue?vue&type=script&lang=js"
export * from "./IWImage.vue?vue&type=script&lang=js"
import style0 from "./IWImage.vue?vue&type=style&index=0&id=60bc49e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bc49e2",
  null
  
)

export default component.exports